import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './user';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import {map, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  private REDIRECT_STORAGE_NAME: string = "redirectUrl";
  private TOKEN_STORAGE_NAME: string = "token";
  private _user: User | undefined;

  constructor(private oidcAuthService: OidcSecurityService,
    private router: Router) { }

    public checkAuth() {
      return this.oidcAuthService.checkAuth();
    }
  
  public checkLoginAndRedirect() {
    return this.oidcAuthService.checkAuth().pipe(
      tap(({ isAuthenticated, userData, accessToken, idToken }) => {
        if (!isAuthenticated) {
          this.doLogin();
        }
        this.setUser(userData);
        this.setToken();
      }));
  }

  public setToken(): void {
    localStorage.setItem(this.TOKEN_STORAGE_NAME, this.oidcAuthService.getIdToken());
  }

  get redirectLocalPath() {
    return sessionStorage.getItem(this.REDIRECT_STORAGE_NAME) as string;
  }

  set redirectLocalPath(value: string) {
    sessionStorage.setItem(this.REDIRECT_STORAGE_NAME, value);
  }

  doLogin() {
    this.oidcAuthService.authorize();
  }

  // get userData(): Observable<object> {
  //   return this.oauthService.userData$;
  // }

  getUserData(): Observable<any> {
    return this.oidcAuthService.userData$;
  }

  public setUser(user: User | object) {
    localStorage.setItem("user", JSON.stringify(user));
  }

  login(): void {
    this.oidcAuthService.authorize();
  }

  logout(): void {
    this.oidcAuthService.logoff();
  }

  logoutLocal(): void {
    this.oidcAuthService.logoffAndRevokeTokens();
  }

  getAccessToken(): string | null {
    return this.oidcAuthService.getAccessToken();
  }

  clearAllCookies(): void {
    debugger
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
    }
  }
}
